import {Concept} from 'types';
import type {Column, ViewMode} from '../types';

export const filterColumnsByType = (
  allColumns: Column[],
  type: ViewMode,
  columns?: string[],
): string[] | undefined => {
  return type === Concept.work
    ? (columns ?? []).filter(
        column => allColumns.find(a => a.name === column)?.workColumn,
      )
    : columns;
};
